export function mergeKeys(...keySets) {
  const map = new Map();
  keySets.forEach((keyset) =>
    keyset.forEach((key) => {
      map.set(key, true);
    })
  );
  return [...map.keys()];
}
